export default "__VITE_ASSET__BT0F3Csx__"